export const CategoryList = [
  {
    id: 1,
    title: 'business',
    color: '#007aff',
  },
  {
    id: 2,
    title: 'personal',
    color: '#ff2d55',
  },
]
